module.exports = __webpack_public_path__ + "static/media/business.85f7bb48.jpg";